import {
  Combobox,
  ComboboxInput,
  ComboboxOption,
  ComboboxOptions,
} from '@headlessui/react';
import { ArrowRightIcon } from '@heroicons/react/24/solid';
import { clsx } from 'clsx';
import Image from 'next/image';
import React, { useState } from 'react';
import { Button, Input } from 'ui';
import usePredictiveSearch from '~/hooks/usePredictiveSearch';
import { RailsPredictiveSearchResult } from '~/typings/services/rails/predictiveSearch';

interface Props {
  onSelect: (
    result: RailsPredictiveSearchResult | null,
    searchText: string,
  ) => void;
  value: RailsPredictiveSearchResult | null;
}

const SellNowPredictive: React.FC<Props> = ({ onSelect, value }) => {
  const [query, setQuery] = useState('');
  const [results] = usePredictiveSearch(query, ['sell_now']);

  return (
    <Combobox
      onChange={result => {
        if (result) {
          onSelect(result, query);
        }
      }}
      value={value}
    >
      <div className="relative">
        <div className="flex">
          <ComboboxInput
            as={Input}
            onChange={e => setQuery(e.target.value)}
            value={query}
            displayValue={(result: RailsPredictiveSearchResult) =>
              result?.name ?? ''
            }
            className="!h-14 rounded-r-none"
            placeholder="Enter a category, brand, model, or other detail"
          />

          <Button
            className="rounded-l-none"
            onClick={() => onSelect(null, query)}
          >
            Start Listing
          </Button>
        </div>

        <ComboboxOptions
          as="ul"
          className="bg-full absolute w-full overflow-y-scroll rounded border-b border-l border-r bg-white py-1 shadow-lg"
          style={{
            maxHeight: 400,
          }}
        >
          {results?.map(result => (
            <ComboboxOption key={result.id} value={result} as={React.Fragment}>
              {({ focus }) => (
                <li
                  className={clsx(
                    'flex space-x-4 px-4 py-1',
                    focus && 'bg-grey-200 text-blue-500',
                  )}
                >
                  {result.thumb_url ? (
                    <Image
                      alt=""
                      src={result.thumb_url}
                      height={40}
                      width={40}
                      className="h-12 w-12 flex-shrink-0 rounded"
                    />
                  ) : (
                    <div className="h-12 w-12 flex-shrink-0" />
                  )}
                  <div>
                    <div>{result.name}</div>
                    <div className="text-brand-500 flex items-center space-x-2 text-sm underline">
                      <div>Start Listing</div>
                      <ArrowRightIcon className="h-3 w-3" />
                    </div>
                  </div>
                </li>
              )}
            </ComboboxOption>
          ))}
        </ComboboxOptions>
      </div>
    </Combobox>
  );
};

export default SellNowPredictive;
